/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PhotoResponse } from './';
import {
    PhotoResponseFromJSON,
    PhotoResponseFromJSONTyped,
    PhotoResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ShortlistProfileResponse
 */
export interface ShortlistProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof ShortlistProfileResponse
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof ShortlistProfileResponse
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof ShortlistProfileResponse
     */
    url: string;
    /**
     * 
     * @type {PhotoResponse}
     * @memberof ShortlistProfileResponse
     */
    photo: PhotoResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShortlistProfileResponse
     */
    badges: Array<ShortlistProfileResponseBadgesEnum>;
}


/**
 * @export
 */
export const ShortlistProfileResponseBadgesEnum = {
    _1: 'SUPER_MALTER_1',
    _2: 'SUPER_MALTER_2',
    _3: 'SUPER_MALTER_3'
} as const;
export type ShortlistProfileResponseBadgesEnum = typeof ShortlistProfileResponseBadgesEnum[keyof typeof ShortlistProfileResponseBadgesEnum];


/**
 * Check if a given object implements the ShortlistProfileResponse interface.
 */
export function instanceOfShortlistProfileResponse(value: object): value is ShortlistProfileResponse {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('photo' in value) || value['photo'] === undefined) return false;
    if (!('badges' in value) || value['badges'] === undefined) return false;
    return true;
}

export function ShortlistProfileResponseFromJSON(json: any): ShortlistProfileResponse {
    return ShortlistProfileResponseFromJSONTyped(json, false);
}

export function ShortlistProfileResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShortlistProfileResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'profileId': json['profileId'],
        'url': json['url'],
        'photo': PhotoResponseFromJSON(json['photo']),
        'badges': json['badges'],
    };
}

export function ShortlistProfileResponseToJSON(value?: ShortlistProfileResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'accountId': value['accountId'],
        'profileId': value['profileId'],
        'url': value['url'],
        'photo': PhotoResponseToJSON(value['photo']),
        'badges': value['badges'],
    };
}

